export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.3542 3.17684C7.14667 3.07307 6.89502 3.12571 6.74648 3.30396L5.18341 5.17965C4.91202 5.50531 5.1436 5.99974 5.56752 5.99974H12H18.4325C18.8564 5.99974 19.088 5.50531 18.8166 5.17965L17.2535 3.30396C17.105 3.12571 16.8533 3.07307 16.6458 3.17684L12 5.49974L7.3542 3.17684ZM2.5 6.99974C2.22386 6.99974 2 7.2236 2 7.49974V9.49974C2 9.77588 2.22386 9.99974 2.5 9.99974H11V6.99974H2.5ZM21.5 6.99974C21.7761 6.99974 22 7.2236 22 7.49974V9.49974C22 9.77588 21.7761 9.99974 21.5 9.99974H13V6.99974H21.5ZM4 11.9997H11V20.9997H5.5C4.67157 20.9997 4 20.3282 4 19.4997V11.9997ZM13 11.9997H20V19.4997C20 20.3282 19.3284 20.9997 18.5 20.9997H13V11.9997Z"
                fill="#7C1D1D"
            />
        </svg>
    );
}
